import React, { Component } from "react";
import { Redirect } from "react-router";

import Container from "react-bootstrap/Container";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Button from "react-bootstrap/Button";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { toast } from "react-toastify";

import config from "../config.json";

import ApiNameView from "./common/apiNameView";

import ApiSettingsService from "../services/apiSettingsService";
import { isAdmin } from "../services/authService";

import ConfirmationModalContextProvider from "./common/modalConfirmationContext";

import _ from "lodash";
import ApiKey from "./common/apiKey";
import dictionary from "../PL.json";
import AnnouncementsTable from "./AnnouncementsTable";
import AnnouncementsIntegration from "./AnnouncmentsIntegration";

class Integration extends Component {
  state = {
    api_key: {},
    toShow: "",
  };

  async componentDidMount() {
    //Get path from url
    const path = this.props.location.pathname;
    let model = "";
    if (path.includes("integration_key")) this.setState({ toShow: "apiKey" });
    else if (path.includes("integration_general")) this.setState({ toShow: "general" });
    else if (path.includes("integration_cashbox")) this.setState({ toShow: "cashbox" });

    // await this.refreshData();
  }

  refreshData = async () => {
    try {
      const { data: apiSettings } = await ApiSettingsService.getAll();
      this.setState({ apiSettings });
    } catch (err) {
      toast.error("Błąd serwera!!!", { autoClose: true, pauseOnFocusLoss: false, duration: 1000 });
      this.props.history.push("/not-found");
    }
  };

  render() {
    if (!isAdmin()) return <Redirect to="/shops" />;
    const { apiSettings } = this.state;

    return (
      <React.Fragment>
        <ConfirmationModalContextProvider>
          <Breadcrumb style={{ backgroundColor: "#DDDDDD" }}>
            <Breadcrumb.Item
              style={{
                marginTop: 3,
                marginLeft: 3,
                marginBottom: 3,
                marginRight: 0,
              }}
              href="/"
            >
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item
              style={{
                marginTop: 3,
                marginLeft: 3,
                marginBottom: 3,
                marginRight: 0,
              }}
              active
            >
              Integracja
            </Breadcrumb.Item>
            <Breadcrumb.Item
              style={{
                marginTop: 3,
                marginLeft: 3,
                marginBottom: 3,
                marginRight: 0,
              }}
              active
            >
              {this.state.toShow === "apiKey" && "Klucz API"}
              {this.state.toShow === "general" && "Komunikaty ogólne"}
              {this.state.toShow === "cashbox" && "Komunikaty kas"}
            </Breadcrumb.Item>
          </Breadcrumb>
          <Container>
            {this.state.toShow === "apiKey" && (
              <ApiKey
                key={"apiKey"}
                enable={false}
                model={"apiModel"}
                onRefreshData={this.refreshData}
              />
            )}

            {this.state.toShow !== "apiKey" && <AnnouncementsIntegration type={this.state.toShow} />}
          </Container>
        </ConfirmationModalContextProvider>
      </React.Fragment>
    );
  }
}

export default Integration;
